"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedarrowssm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedarrowssm` : '') + (description ? ` desc-brandedarrowssm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedarrowssm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedarrowssm"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.814 5.194C7.177 5.564 6.804 5.883 6.727 5.965 6.348 6.366 5.715 6.384 5.314 6.005 4.912 5.626 4.894 4.993 5.273 4.592 5.529 4.32 6.08 3.888 6.81 3.465 7.557 3.031 8.549 2.572 9.708 2.286 12.056 1.707 15.075 1.845 18.027 4.251 20.448 6.225 21.359 8.811 21.624 10.95 21.704 11.597 21.726 12.208 21.712 12.758L22.404 12.245C22.848 11.916 23.474 12.009 23.803 12.453 24.132 12.896 24.039 13.523 23.596 13.852L20.326 16.276 17.244 13.663C16.822 13.306 16.77 12.675 17.127 12.254 17.485 11.832 18.116 11.78 18.537 12.138L19.695 13.119C19.731 12.564 19.727 11.905 19.639 11.196 19.417 9.407 18.675 7.36 16.763 5.801 14.381 3.86 12.036 3.772 10.187 4.228 9.248 4.46 8.432 4.835 7.814 5.194ZM16.186 18.806C16.823 18.436 17.196 18.117 17.273 18.036 17.652 17.634 18.285 17.616 18.686 17.995 19.088 18.374 19.106 19.007 18.727 19.408 18.471 19.68 17.92 20.112 17.19 20.535 16.443 20.969 15.451 21.428 14.292 21.714 11.944 22.293 8.925 22.155 5.973 19.749 3.552 17.775 2.641 15.189 2.376 13.05 2.296 12.403 2.274 11.792 2.288 11.242L1.596 11.755C1.152 12.084.526 11.991.197 11.547-.132 11.104-.039 10.477.404 10.148L3.674 7.724 6.756 10.337C7.178 10.694 7.23 11.325 6.873 11.746 6.515 12.168 5.884 12.22 5.463 11.863L4.305 10.881C4.269 11.436 4.274 12.095 4.361 12.804 4.583 14.593 5.325 16.64 7.237 18.199 9.619 20.14 11.964 20.228 13.813 19.772 14.753 19.54 15.568 19.165 16.186 18.806Z",
    fill: "#F26B1C"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = brandedarrowssm;